import React, { Component } from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';
import Config from '../config/config';
import { toggleModal } from '../lib/util';
import './NewsModal.css';

class NewsModal extends Component {

  componentDidMount(){
    toggleModal(true);
  }

  componentWillUnmount(){
    toggleModal(false);
  }

  render(){
    const {
      history, location
    } = this.props;
    const {
      date, title, content, imageArray, newstype
    } = this.props.data;
    const dateObj = new Date(date);
    const dateStr = `${dateObj.getFullYear()}-${dateObj.getMonth()+1}-${dateObj.getDate()}`;

    console.log(imageArray);
    const image = imageArray ? imageArray[0] : false;
    const imageUrl = image && image.url ? `${Config.apiUrl}${image.url}` : null;

    const back = (e) => {
      if(location.state && location.state.filter){
        history.goBack();
      }else{
        history.push({
          pathname: '/news/all',
        })
      }
    };

    return (
      <div className="modal news-modal is-active" >
        <div className="modal-background" role="button" tabIndex={0} onClick={back} onKeyUp={back} />
        <div className="modal-content">
          <div className="card">
            <button className="card-close" aria-label="close" onClick={back}>
              <FontAwesomeIcon icon={faTimes}/>
            </button>
            <div className="card-content">
              <div className="media">
                {!imageUrl && <div className="media-left">
                  <figure className={`image is-48x48 type-${newstype.name}`} />
                </div>}
                <div className="media-content">
                  <div className="content">
                    <div className="content-header">
                      <div className="content-header-date has-text-grey-light">{dateStr}</div>
                      <div className="content-header-type">{newstype.title}</div>
                    </div>
                    <div className="content-header-title">{title}</div>
                  </div>
                </div>
              </div>
              <div className="card-content-body">
                {imageUrl && <img src={imageUrl} alt={title} />}
                <div className="content content-body" dangerouslySetInnerHTML={{ __html: marked(content) }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
};

NewsModal.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    id: PropTypes.string,
  }),
  match: PropTypes.shape({}),
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }),
};

NewsModal.defaultProps = {
  data: {
    date: new Date().toISOString(),
    type: 'news',
    title: 'Dummy title',
    content: 'Dummy content'
  },
  match: {},
  history: {
    goBack: () => {},
  },
};

export default NewsModal;



// WEBPACK FOOTER //
// ./src/components/NewsModal.js